export enum RoleName {
    USER = "user",
    MERCHANT = "merchant",
    ADVISOR = "advisor",
    ADMIN = "admin",
    ADMIN_N2 = "admin_n2",
    ADMIN_FINANCE = "admin_finance",
    SUPER_ADMIN = "super_admin",
}
